"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ordinalSuffix = function ordinalSuffix(i) {
  var j = i % 10,
      k = i % 100;

  if (j === 1 && k !== 11) {
    return i + "st";
  }

  if (j === 2 && k !== 12) {
    return i + "nd";
  }

  if (j === 3 && k !== 13) {
    return i + "rd";
  }

  return i + "th";
};

var Rank = function Rank(_ref) {
  var className = _ref.className,
      style = _ref.style,
      children = _ref.children;
  var formatted = ordinalSuffix(children);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: className,
    style: style,
    children: formatted
  });
};

var _default = Rank;
exports.default = _default;